module.exports = __webpack_public_path__ + "img/key.0ba7eca2.svg";